/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AddOpenAPIv3DeploymentAssetForm = {
  /**
   * The ID of the uploaded asset.
   */
  assetId: string;
  /**
   * The name to give the document as it will be displayed in UIs.
   */
  name: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
};

/** @internal */
export type AddOpenAPIv3DeploymentAssetForm$Outbound = {
  asset_id: string;
  name: string;
  slug: string;
};

/** @internal */
export const AddOpenAPIv3DeploymentAssetForm$outboundSchema: z.ZodMiniType<
  AddOpenAPIv3DeploymentAssetForm$Outbound,
  AddOpenAPIv3DeploymentAssetForm
> = z.pipe(
  z.object({
    assetId: z.string(),
    name: z.string(),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      assetId: "asset_id",
    });
  }),
);

export function addOpenAPIv3DeploymentAssetFormToJSON(
  addOpenAPIv3DeploymentAssetForm: AddOpenAPIv3DeploymentAssetForm,
): string {
  return JSON.stringify(
    AddOpenAPIv3DeploymentAssetForm$outboundSchema.parse(
      addOpenAPIv3DeploymentAssetForm,
    ),
  );
}
